import { render, staticRenderFns } from "./NeedAuth.vue?vue&type=template&id=22fb9a22&"
import script from "./NeedAuth.vue?vue&type=script&lang=js&"
export * from "./NeedAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports